var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStart = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 20,
  viewBox: "0 0 18 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.95704 19.2095C9.68436 19.6968 9.17384 19.9113 8.71938 19.9169C8.26587 19.9225 7.74318 19.7194 7.47489 19.2177L7.28324 18.8593C4.36642 13.4052 2.02906 7.71949 0.299871 1.87126C0.11474 1.24513 0.464075 0.723946 0.880841 0.473883C1.29616 0.224684 1.88367 0.165129 2.3869 0.482943L7.7903 3.89547C8.46029 4.3186 9.40984 4.31304 10.1116 3.86178L15.6269 0.314947C16.1234 -0.00428772 16.7086 0.0296211 17.1325 0.278385C17.5641 0.531591 17.893 1.06337 17.6903 1.6862C15.7728 7.57744 13.2525 13.3206 10.1603 18.8463L9.95704 19.2095Z",
  fill: "#3D8A55"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgStart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/start.ea47328cb910df59e66d41368fc5fa1b.svg";